"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function edo(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M9.79496 17.9055L11.8072 15.8828L13.8277 17.9055L12.5385 19.197C12.4425 19.2932 12.3285 19.3695 12.2031 19.4216C12.0776 19.4737 11.9431 19.5005 11.8072 19.5005C11.6713 19.5005 11.5368 19.4737 11.4113 19.4216C11.2859 19.3695 11.1719 19.2932 11.076 19.197L9.79496 17.9055ZM15.0075 10.974L12.9885 8.95127L15.0082 6.92851L17.0272 8.95127L15.0075 10.974ZM14.5057 17.2463L12.486 15.2235L17.9085 9.79202L19.197 11.0828C19.6012 11.4878 19.6012 12.1425 19.197 12.5475L14.5057 17.2463ZM8.95345 17.0378L6.93445 15.015L12.348 9.59252L14.367 11.6153L8.95345 17.0378ZM6.08695 14.1878L4.7977 12.8963C4.60517 12.7007 4.49807 12.4367 4.4999 12.1623C4.50173 11.8878 4.61233 11.6253 4.80745 11.4323L6.09595 10.1408L8.1157 12.1643L6.08695 14.1878ZM14.1622 6.09676L8.7397 11.5253L6.71995 9.50252L11.4112 4.80301C11.5071 4.70682 11.6211 4.6305 11.7466 4.57842C11.8721 4.52635 12.0066 4.49954 12.1425 4.49954C12.2783 4.49954 12.4128 4.52635 12.5383 4.57842C12.6638 4.6305 12.7778 4.70682 12.8737 4.80301L14.1622 6.09676Z", fill: color }));
}
exports["default"] = edo;
//# sourceMappingURL=edo.js.map